export default __webpack_public_path__ + "03ed5b3d61cfff55ff294f113c58e6af.svg";